import React from 'react';
import { connect } from 'react-redux'
import logo from '../../../src/assets/images/mydigital_logo.svg';
import { NavLink, Link } from 'react-router-dom';
import { Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Config from "../../config/Configs";


const theme = createMuiTheme({
  palette: {
    primary: { 500: '#DA1B2C' },
  }

});

const Header = ({language}) => {
  const {home,sample,digitalDownload,newUser,existingUser}= language  
  return (
    <div>
      <header className="clearfix">
        <Container>
          <div className="my-digital-logo">
           <a  href="https://www.matildaeducation.com.au"> <img src={logo}/> </a>
          </div>
          <nav className="navigation">
            <NavLink to="/" exact>{home}</NavLink>
            <NavLink to="/samples" exact>{sample}</NavLink>
            <span className="digital-download-seprator"></span>
            <NavLink to="/digitaldownload" exact  className="digital-download">{digitalDownload}</NavLink>
          </nav>
          <div className="header-right-buttons">
              <a variant="contained" className="login-button" color="primary"  target="_blank" href={Config.loginUrl}>
                {existingUser}
            </a>
            
            <a variant="contained" className="create-account-button" target="_blank" href={Config.signupUrl}>
              {newUser}
            </a>
            
          </div>
        </Container>
      </header>
      <div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const {home,sample,digitalDownload,newUser,existingUser}= state.Language
  return {
      language :{home,sample,digitalDownload,newUser,existingUser}
  }
}

export default connect(mapStateToProps)(Header)

